import {JsonConfigInterface} from './json-config-interface';
import {Utils} from '@astek/utils';

export type ResultsVersionsConfigJson = {
  maxV1: string;
};

export class ResultsVersionsConfig implements JsonConfigInterface<ResultsVersionsConfigJson> {

  private _maxV1: string = '';

  constructor(json?: ResultsVersionsConfigJson) {
    if(Utils.isNotNullOrUndefined(json)) {
      this.deserializeJson(json);
    }
  }

  public get maxV1(): string {
    return this._maxV1;
  }

  public deserializeJson(json: ResultsVersionsConfigJson): void {
    this._maxV1 = json.maxV1;
  }
}
